import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Logo from "../images/logo_usi.svg"

export default class Header extends Component{
  render(){
    return(
      <div className="row">
        <div className="col-xs-12 header">
          <Link to="/">
          <img src={ Logo } alt="" className="logo" />
          </Link>
          <h1 className="text-center">Unit&eacute; de Syst&egrave;mes d’Information</h1>
          <h3>La Technologie au Service du MENFP</h3>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components/Header.js